// src/api/onboarding.ts

import { apiJson } from "./client";

export type SourceTodo = {
  connector_type: string;
  display_name?: string;
  status: "pending" | "connected" | "dismissed";
  data_source_id?: string;
};

export type OnboardingState = {
  current_step?: string;
  completed_steps?: string[];
  industry?: string;
  dwh?: {
    initiated?: boolean;
    bq_location?: string;
  };
  source_todos?: SourceTodo[];
  started_at?: string;
  completed_at?: string;
};

export type OnboardingResponse = {
  industry: string | null;
  onboarding_status: string | null;
  onboarding_state: OnboardingState | null;
  dwh_provisioning_status: string | null;
  dwh_storage_mode: string | null;
  dwh_project_id: string | null;
};

export type OnboardingUpdatePayload = {
  industry?: string;
  current_step?: string;
  completed_steps?: string[];
  source_todos?: Array<{
    connector_type: string;
    display_name?: string;
    status?: string;
    data_source_id?: string;
  }>;
  dwh?: Record<string, unknown>;
};

/** GET /accounts/onboarding */
export async function getOnboarding(): Promise<OnboardingResponse> {
  return apiJson<OnboardingResponse>("/accounts/onboarding", {
    unwrapData: false,
  });
}

/** PATCH /accounts/onboarding */
export async function updateOnboarding(
  payload: OnboardingUpdatePayload
): Promise<OnboardingResponse> {
  return apiJson<OnboardingResponse>("/accounts/onboarding", {
    method: "PATCH",
    body: JSON.stringify(payload),
    unwrapData: false,
  });
}

/** POST /accounts/onboarding/complete */
export async function completeOnboarding(
  status: "COMPLETED" | "SKIPPED"
): Promise<OnboardingResponse> {
  return apiJson<OnboardingResponse>("/accounts/onboarding/complete", {
    method: "POST",
    body: JSON.stringify({ status }),
    unwrapData: false,
  });
}
